export function PrivacyPolicy() {
    return (
      <div className="max-w-4xl mx-auto p-6 text-gray-800">
        {/* כותרת ראשית */}
        <h1 className="text-3xl font-bold mb-6">מדיניות פרטיות ותנאי שימוש</h1>
  
        {/* חלק פתיחה */}
        <p className="mb-4">
          ברוכים הבאים ל… (להלן: <strong>AniZone.co.il</strong>). האתר מופעל ע”י … (ע.מ: ……) (להלן: “הנהלת האתר” או “החברה”).
          
        </p>
  
        {/* כללי */}
        <h2 className="text-2xl font-semibold mb-4">כללי</h2>
        <p className="mb-4">
          האמור בתקנון זה מתייחס באופן שווה לבני שני המינים, והשימוש בלשון זכר הוא מטעמי נוחות בלבד.
        </p>
        <p className="mb-4">
          הוראות תקנון זה ותנאי השימוש המופיעים באתר מגדירים את מערכת היחסים המשפטית בין המזמין לבין האתר, את תנאי השימוש באתר ו/או
          את הזמנת המוצרים מן האתר ומעידים על הסכמת המזמין, לתנאים אלה ולתנאים נוספים המופיעים באתר.
        </p>
        <p className="mb-4">
          החברה רשאית בכל עת, על פי שיקול דעתה הבלעדי, לעדכן תקנון זה.
        </p>
        <p className="mb-4">
          תנאים אלה חלים על השימוש באתר ובשירותים הכלולים בו באמצעות כל מחשב או מכשיר תקשורת אחר (כדוגמת טלפון סלולארי, טבלטים למיניהם וכו’) כמו כן
          הם חלים על השימוש באתר, בין באמצעות רשת האינטרנט ובין באמצעות כל רשת או אמצעי תקשורת אחר.
        </p>
        <p className="mb-4">
          אין באמור בתקנון זה כדי לגרוע מהוראות חוק הגנת הצרכן, התשמ”א-1981 (להלן: “חוק הגנת הצרכן”) והתקנות אשר הותקנו מכוחו, ככל שהן חלות על האתר
          (להלן: “ההוראות”), למעט במקרים בהם ניתן להתנות על הוראות כאמור והתניה כאמור בוצעה במסגרת האתר אם במפורש ואם במשתמע.
        </p>
        <p className="mb-4">
          החברה והנהלת האתר עושים כמיטב יכולתם להציג את המידע השלם והמקיף ביותר לגבי המוצר לרבות תמונות, חרף האמור בסעיף זה יובהר, כי עלולים
          להופיע באתר בתום לב וללא כוונת זדון ו/או מתוך רצון להטעות, אי דיוקים ו/או שגיאות ו/או השמטות והחברה, הנהלת האתר והאתר לא יישאו באחריות כלשהי הנובעת
          ממאי הדיוקים ו/או או השגיאות.
        </p>
        <p className="mb-4">
          כותרות הפרקים מובאות לשם נוחות והתמצאות המזמין ולא ישמשו בפרשנות התקנון.
        </p>
        <p className="mb-4">
          טעות סופר בתיאור מוצר/ים לא תחייב את החברה.
        </p>
        <p className="mb-4">
          תמונות המוצרים באתר מוצגות לצורכי המחשה בלבד. בנוסף, ייתכנו הבדלים במראה, בגוון, בגודל, וכיו”ב בין המוצר, כפי שהוא מוצג באתר, לבין המוצר במציאות.
        </p>
        <p className="mb-4">
          אין להעתיק ולהשתמש, או לאפשר לאחרים להשתמש, בכל דרך אחרת בתכנים מתוך האתר, לרבות באתרי אינטרנט אחרים, בפרסומים אלקטרוניים,
          בפרסומי דפוס וכיו”ב, לכל מטרה אחרת.
        </p>
        <p className="mb-4">
          המועד שנרשם, לכל עניין ועניין, במחשבי החברה הוא המועד הקובע לכל דבר.
        </p>
  
        {/* הרשמה לאתר */}
        <h2 className="text-2xl font-semibold mb-4">הרשמה לאתר</h2>
        <p className="mb-4">
          על מנת לבצע הזמנה של מוצרים על המזמין להירשם באתר באמצעות טופס הרשמה מקוון.
        </p>
        <p className="mb-4">
          כל אדם, לרבות חברה, רשאי להשתמש באתר, לרבות לבצע רכישות באמצעות האתר, בין היתר, בכפוף להיותו כשיר לבצע פעולות משפטיות מחייבות,
          בעל כרטיס אשראי תקף, שהונפק ע”י אחת מחברות כרטיסי האשראי (לעיל ולהלן: “המזמין”).
        </p>
        <p className="mb-4">
          הרישום הינו חד פעמי, כאשר לאחריו המזמין לא יידרש לשוב ולהירשם בכל פעם מחדש בעת ביצוע הרכישה.
        </p>
        <p className="mb-4">
          בעת הרישום באתר על המזמין להזין שם משתמש וסיסמא וכן את כתובת הדואר האלקטרוני שלו. במידה וישכח המזמין את הסיסמא, תשלח אליו הסיסמא
          הקיימת כפי שהוזנה בעת הרישום הראשוני באתר לכתובת הדוא”ל אשר הוזנה באתר.
        </p>
        <p className="mb-4">
          בעתיד אם וכאשר יבקש המזמין לרכוש מוצרים נוספים, יזוהה המזמין לפי שם המזמין והסיסמא שבחר.
        </p>
        <p className="mb-4">
          פרטי המזמין יעודכנו בהתאם לנתונים אשר ימולאו על ידי המזמין בטופס ההרשמה המקוון במצוי באתר.
        </p>
        <p className="mb-4">
          הנהלת האתר רשאית מעת לעת לדרוש פרטי זיהוי נוספים.
        </p>
        <p className="mb-4">
          מבלי לגרוע מהאמור לעיל, החברה תהא רשאית למנוע מכל אדם להשתמש באתר, באופן זמני או לצמיתות על פי שיקול דעתה הבלעדי ומבלי למסור
          הודעה על כך מראש, לרבות בכל אחד מהמקרים הבאים:
        </p>
        <ul className="text-softText list-disc list-inside mb-4">
          <li>ביצוע מעשה בלתי חוקי ו/או הפרת הוראות הדין;</li>
          <li>הפרת תנאי מתנאי תקנון זה;</li>
          <li>מסירת פרטים שגויים במתכוון;</li>
          <li>ביצוע פעולה העלולה לפגוע בפעילותו התקינה של האתר ו/או במי מהספקים ו/או בצד ג’ כלשהו;</li>
          <li>כרטיס האשראי שברשות המזמין נחסם או הוגבל לשימוש בדרך כלשהי.</li>
        </ul>
  
        {/* רכישת מוצרים באתר */}
        <h2 className="text-2xl font-semibold mb-4">רכישת מוצרים באתר</h2>
        <p className="mb-4">
          רכישת המוצרים תתבצע באמצעות הוספת מוצרים לסל הקניות, לאחר הוספת מוצרים לסל הקניות יזין המזמין בטופס המקוון המיועד לכך בתהליך
          ההזמנה את פרטי המזמין הבאים: שם פרטי, שם משפחה, מס’ טלפון, כתובת דואר אלקטרוני, בנוסף יש למסור את פרטי מקבל ההזמנה, שם פרטי,
          שם משפחה, מס’ טלפון, יישוב, רחוב, מס’ בית, קומה, דירה, כניסה וכל פרט מזהה אחר לסיוע במשלוח.
        </p>
        <p className="mb-4">
          השדות המסומנים בכוכבית קיימת חובה למלאם ובלעדיהם לא תתאפשר השלמת ההזמנה.
        </p>
        <p className="mb-4">
          על מנת למנוע כל אפשרות של תקלה במשלוח, המזמין נדרש למסור פרטים מדויקים ונכונים.
        </p>
        <p className="mb-4">
          בעת פעולת השלמת ההזמנה יאשר המזמין את פרטי ההזמנה ואת נכונות הפרטים שמסר.
        </p>
        <p className="mb-4">
          מילוי כל הפרטים מהווה תנאי מוקדם לביצוע ההזמנה, וזאת לשם ביצוע ההזמנה ביעילות וללא תקלות.
        </p>
        <p className="mb-4">
          פרטי המזמין יעודכנו בהתאם למידע שמסרתו בטופס ההזמנה המקוון באתר.
        </p>
        <p className="mb-4">
          מילוי כל הפרטים הנדרשים לרכישת המוצר על ידי המזמין יחשב לביצוע הזמנה (להלן: “ההזמנה”) עם קבלת ההזמנה, ולאחר קבלת ההזמנה, האתר
          יבצע בדיקה של פרטי כרטיס האשראי ורק לאחר אישור חברת האשראי ו/או קבלת אישור מפיי פאל, תצא אישור סופי של ההזמנה וחיוב הלקוח
          יתבצע בהתאם.
        </p>
  
        {/* אופן ביצוע התשלום */}
        <h2 className="text-2xl font-semibold mb-4">אופן ביצוע התשלום עבור ההזמנה</h2>
        <p className="mb-4">
          התשלום עבור המוצרים יתבצע באמצעות כרטיס אשראי או חשבון בשירות “ארנק אלקטרוני” כדוגמת <a href="https://www.paypal.com" className="text-blue-600 hover:underline">פיי פאל</a> וכל שירות דומה,
          כפי שיהיה זמין לשימוש באתר, לפי שיקול דעתה של הנהלת האתר.
        </p>
        <p className="mb-4">
          במקרה של שימוש בכרטיס אשראי, יתבקש המזמין למסור את פרטי כרטיס האשראי, תעודת זהות, סוג הכרטיס ותוקפו. במידה והמזמין בחר בתשלום באמצעות פיי פאל, החברה תוכל לגבות את התשלום רק לאחר קבלת אישור.
        </p>
        <p className="mb-4">
          הנהלת האתר שומרת לעצמה את הזכות לשנות את אמצעי התשלום המותרים ולהחיל הסדרי תשלום שונים במידת הצורך.
        </p>
        <p className="mb-4">
          לאחר הזנת פרטי התשלום, יישלח למזמין אישור בדואר אלקטרוני על קליטת ההזמנה. אישור זה אינו מהווה התחייבות לסיפוק המוצרים עד לבדיקת אמצעי התשלום.
        </p>
        <p className="mb-4">
          מיד לאחר ביצוע ההזמנה, תתבצע בדיקת אמצעי התשלום, ובהתאם לכך יישלח למזמין אישור על ביצוע ההזמנה וחיוב חשבונו.
        </p>
        <p className="mb-4">
          במידה ואמצעי התשלום לא יאושרו על ידי חברת האשראי או פיי פאל, תקבל הודעה מתאימה והמזמין יצור קשר להשלמת העסקה או לביטולה.
        </p>
  
        {/* אספקה והובלת מוצרים */}
        <h2 className="text-2xl font-semibold mb-4">אספקה והובלת מוצרים</h2>
        <p className="mb-4">
          אספקת המוצרים תתבצע רק לאחר קבלת אישור תשלום מאת חברת האשראי או פיי פאל, והמוצר יסופק לכתובת שנמסרה בעת ביצוע ההזמנה.
        </p>
        <p className="mb-4">
          האתר מתחייב לספק את המוצרים בתוך מסגרת זמן הסבירה, בהתאם לתנאי משלוח מוגדרים: עד 14 ימי עסקים למשלוח בדואר רשום, ועד 3 ימי עסקים למשלוח באמצעות שליח.
        </p>
        <p className="mb-4">
          המשלוחים יתבצעו בהתאם לתנאי חברת המשלוחים ובתיאום מראש עם מקבל ההזמנה.
        </p>
        <p className="mb-4">
          במקרה בו לא תתאפשר אספקה לכתובת שנמסרה, הנהלת האתר תודיע ותפעל למציאת פתרון חלופי.
        </p>
        <p className="mb-4">
          במקרה של מוצרים שאינם במלאי, האתר רשאי לבטל את ההזמנה או להציע פריט חלופי שווה ערך. במקרה זה, המזמין לא יהיה רשאי לתבוע נזק עבור אי אספקת המוצר.
        </p>
  
        {/* ביטול רכישה */}
        <h2 className="text-2xl font-semibold mb-4">ביטול רכישה</h2>
        <p className="mb-4">
          <strong>ביטול רכישה מצד המזמין:</strong> המזמין רשאי לבטל את העסקה בהתאם להוראות חוק הגנת הצרכן והתקנות, אך הביטול ייעשה אך ורק בהודעה בכתב לכתובת הדוא”ל ………
        </p>
        <p className="mb-4">
          ביטול העסקה מצידו של המזמין יתאפשר רק במוצרים מסוימים, וכפוף להחזרת המוצר באריזתו המקורית. לאחר קבלת הודעת הביטול, יוחזר למזמין הסכום ששולם בניכוי דמי ביטול (5% מסכום העסקה או 100 ש”ח, לפי הנמוך). במקרה של ביטול עקב פגם או אי התאמה, לא יחויב המזמין בדמי ביטול.
        </p>
        <p className="mb-4">
          <strong>ביטול רכישה מצד החברה:</strong> החברה רשאית, על פי שיקול דעתה, לבטל עסקה מסיבות שונות ולהודיע למזמין בהתאם, כך שלא יחול חיוב על כרטיס האשראי או יוחזר הסכום ששולם.
        </p>
  
        {/* זכויות יוצרים */}
        <h2 className="text-2xl font-semibold mb-4">זכויות יוצרים</h2>
        <p className="mb-4">
          כל זכויות הקניין הרוחני, לרבות פטנטים, זכויות יוצרים, הדגמים, המדגמים והסודות המסחריים, הם רכוש החברה בלבד או צדדים שלישיים שהרשו לה שימוש.
        </p>
        <p className="mb-4">
          זכויות אלו חלות גם על שם האתר, שם המתחם (www.—–.com) וסימני המסחר, ואין לעשות בהם שימוש ללא הסכמה כתובה מראש.
        </p>
        <p className="mb-4">
          אין להעתיק, לשכפל, להפיץ, למכור, לשווק, להשכיר או לתרגם מידע מהאתר, לרבות סימני מסחר, תמונות וטקסטים, ללא אישור מראש ובכתב של החברה.
        </p>
        <p className="mb-4">
          אין לקשר לתכנים מהאתר (מלבד דף הבית) או להציגם באופן שלא בהתאם לאישור שניתן על ידי הנהלת האתר.
        </p>
  
        {/* אחריות */}
        <h2 className="text-2xl font-semibold mb-4">אחריות</h2>
        <p className="mb-4">
          החברה (ו/או מי מטעמה) לא תישא באחריות ישירה או עקיפה לנזקים הנובעים מהחלפת, תיקון או שימוש במוצרים.
        </p>
        <p className="mb-4">
          החברה לא אחראית לנזקים הנובעים מהסתמכות על מידע המתפרסם באתרים חיצוניים, ואף לא תישא באחריות על תפקוד האתר.
        </p>
        <p className="mb-4">
          החברה לא תהיה אחראית לכל נזק, ישיר או עקיף, שייגרם עקב חדירה בלתי מורשית למידע או שימוש לא מורשה בו.
        </p>
  
        {/* סודיות ופרטיות */}
        <h2 className="text-2xl font-semibold mb-4">סודיות ופרטיות</h2>
        <p className="mb-4">
          פרטיו האישיים של המזמין (כגון שם, דואר אלקטרוני וכו’) יישמרו במאגרי המידע של החברה.
        </p>
        <p className="mb-4">
          החברה לא תעביר את פרטיו של המזמין לגורם אחר, מלבד ספקים במקרה הצורך לצורך השלמת עסקה.
        </p>
        <p className="mb-4">
          החברה לא תעשה שימוש בפרטי אמצעי התשלום של המזמין, והם לא יאוחסנו במאגרי המידע של החברה.
        </p>
        <p className="mb-4">
          עם זאת, החברה רשאית להעביר את פרטיו של המזמין לצד שלישי במקרים בהם המזמין ביצע מעשה הפוגע בחברה או במקרה של צו שיפוטי.
        </p>
        <p className="mb-4">
          החברה תוכל להשתמש בפרטיו של המזמין לצורך ניתוח סטטיסטי ללא זיהוי אישי ולהציג את המידע לגורמים אחרים.
        </p>
        <p className="mb-4">
          מאחר והפעולות מתבצעות בסביבה מקוונת, אין באפשרותה של החברה להבטיח חסינות מוחלטת מפני חדירות או חשיפת מידע.
        </p>
        <p className="mb-4">
          החברה רשאית לעשות שימוש ב-“עוגיות” (“cookies”) כדי לספק שירות מהיר ולחסוך למשתמש את הצורך להזין את פרטיו בכל כניסה.
        </p>
        <p className="mb-4">
          במקרה של מצבים שאינם בשליטת החברה (כח עליון, וכו’), החברה לא תהיה אחראית לכל נזק שייגרם.
        </p>
  
        {/* דין ושיפוט */}
        <h2 className="text-2xl font-semibold mb-4">דין ושיפוט</h2>
        <p className="mb-4">
          הדין החל על תקנון זה וכל פעולה או סכסוך הנובעים ממנו הוא הדין הישראלי בלבד.
        </p>
        <p className="mb-4">
          במקרה של מחלוקת, בתי המשפט בתל אביב-יפו יהיו בעלי הסמכות הבלעדית לדון בה.
        </p>
        <p className="mb-4">
          הדין החל על השימוש באתר, על ההזמנה ועל תקנון זה הוא הדין הישראלי בלבד.
        </p>
      </div>
    );
  }
  